export type StandaloneNavBadge = 'coming_soon';

export type StandaloneNavItem = {
  id: string;
  label: string;
  path: string;
  badge?: StandaloneNavBadge;
};

type BuildArgs = {
  promotionEngineEnabled: boolean;
  revenueLeakageEnabled: boolean;
};

/**
 * Registry of Specialized Dashboards dropdown items (standalone product surfaces).
 * Signals stays as its own top-nav item — do not add it here.
 * Add future dropdown children here; visibility comes from /api/v1/me flags.
 */
export const buildStandaloneNavItems = ({
  promotionEngineEnabled,
  revenueLeakageEnabled
}: BuildArgs): StandaloneNavItem[] => {
  const items: StandaloneNavItem[] = [];

  if (promotionEngineEnabled) {
    items.push({
      id: 'promotion-engine',
      label: 'Promotion Engine',
      path: '/promotion-engine'
    });
  }

  if (revenueLeakageEnabled) {
    items.push({
      id: 'revenue-leakage',
      label: 'Revenue Leakage',
      path: '/revenue-leakage'
    });
  }

  return items;
};

export const isStandalonePathActive = (pathname: string, path: string) =>
  pathname === path || pathname.startsWith(`${path}/`);

export const isInsightsGroupActive = (pathname: string, items: StandaloneNavItem[]) =>
  items.some((item) => isStandalonePathActive(pathname, item.path));
